import { create } from 'zustand';
import type { CalendarFilterCategory, CalendarView } from '../types';

interface CalendarStore {
  view: CalendarView;
  currentDate: Date;
  visibleRange: { start: Date; end: Date };
  activeFilters: CalendarFilterCategory[];
  setView: (view: CalendarView) => void;
  setCurrentDate: (date: Date) => void;
  setVisibleRange: (range: { start: Date; end: Date }) => void;
  toggleFilter: (category: CalendarFilterCategory) => void;
}

const now = new Date();

export const useCalendarStore = create<CalendarStore>((set, get) => ({
  view: 'month',
  currentDate: now,
  visibleRange: {
    start: new Date(now.getFullYear(), now.getMonth(), 1),
    end: new Date(now.getFullYear(), now.getMonth() + 1, 0),
  },
  activeFilters: ['task', 'google', 'microsoft', 'internal', 'native'],

  setView: (view) => set({ view }),

  setCurrentDate: (date) => set({ currentDate: date }),

  setVisibleRange: (range) => set({ visibleRange: range }),

  toggleFilter: (category) => {
    const current = get().activeFilters;
    const next = current.includes(category)
      ? current.filter((f) => f !== category)
      : [...current, category];
    set({ activeFilters: next });
  },
}));
